export const allowedTypes = [
  'application/pdf',
  'application/wps-office.pdf',
  'application/wps-office.docx',
  'application/wps-office.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/octet-stream'
];
